import dayjs from "utils/dayjs-config";
import { useMemo } from "react";

const mergeFeatureAttachments = (
  featureInstanceData: any,
  revision?: string
) => {
  let featureAttachments = (featureInstanceData.attachments || []).filter(
    (attachment: any) => !attachment?.comment_id
  );

  if (revision !== undefined && revision !== null && revision !== "") {
    featureAttachments = featureAttachments.filter(
      (attachment: any) =>
        String(attachment.submittal_revision) === String(revision)
    );
  }

  const comments = featureInstanceData.comments || [];
  const allCommentAttachments: any[] = [];

  comments.forEach((comment: any) => {
    const attachmentInfo = comment.attachments?.map((attach: any) => ({
      id: attach.id,
      file_name: attach.file_name,
      created_at: comment.created_at,
      created_by_user: comment.created_by_user,
      blob_key: attach.blob_key,
      file_type: attach.file_type
    }));
    if (attachmentInfo?.length) {
      allCommentAttachments.push(...attachmentInfo);
    }
  });

  const mergedAttachments = [...allCommentAttachments, ...featureAttachments];

  return mergedAttachments.sort((a: any, b: any) => {
    return dayjs(b.created_at).diff(dayjs(a.created_at));
  });
};

export const useFeatureAttachments = (
  featureInstanceData?: any,
  revision?: string
) => {
  const attachments = useMemo(() => {
    if (!featureInstanceData) {
      return undefined;
    }
    return mergeFeatureAttachments(featureInstanceData, revision);
  }, [featureInstanceData, revision]);

  return {
    attachments,
    loading: !featureInstanceData
  };
};
